import { render, staticRenderFns } from "./ErrWords.vue?vue&type=template&id=4ae79996&scoped=true"
import script from "./ErrWords.vue?vue&type=script&lang=js"
export * from "./ErrWords.vue?vue&type=script&lang=js"
import style0 from "./ErrWords.vue?vue&type=style&index=0&id=4ae79996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae79996",
  null
  
)

export default component.exports